{
  "organizationLabel": "Organisation :",
  "profileDropdownAccountInfoItem": "Informations sur le compte (internes)",
  "profileDropdownAccountSettingsHeader": "Paramètres du compte",
  "profileDropdownProductSettingsHeader": "Paramètres du produit",
  "profileDropdownUserSettingsItem": "Préférences",
  "profileLegalNoticesMenuItem": "Informations juridiques",
  "signOut": "Se déconnecter",
  "themeInfoTooltip": "Toutes les applications ne prennent pas en charge le thème Sombre.",
  "userProfileName": "{firstName} {lastName}",
  "userThemeSwitchLabel": "Thème sombre"
}
